export default __webpack_public_path__ + "static/media/video.baf744a5.mp4";